<template>
<div class="chapter">
<div class="inner_page">
<h1 class="part11">The Lost Princess of Oz</h1>
<p class="part11_">Book Eleven in the Oz Series</p>
<p class="author">L. Frank Baum<a id="page_i"></a></p><a id="page_i">
<div class="img_container4">
<img alt="Image" src="Book1/images/logo.jpg"/>
</div>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?449b1f59